import { Tracker } from '@studyportals/datalake-event-tracker';

export default class DataLakeEventTracker extends Tracker {
	public get isTrackingFunctionalityAvailable(): boolean {
		return this.tracker && this.tracker.tracker !== null;
	}
}
